import { useCreativeTemplatesBuilderStore } from 'stores/CreativeTemplatesBuilderStore';

export const useImageTab = () => {
  const store = useCreativeTemplatesBuilderStore();

  return { loading: store.isImagesLoading };
};
